<template>
  <div class="wall">
    <div class="wall-head flex-items-center">
      员工列表
      <el-button class="ml-auto" type="primary" size="small" round @click="handleCreate()">
        新增员工
      </el-button>
    </div>
    <div class="mt-35 p-30 container" v-loading="bodyLoding">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="create_time" label="注册时间" width="180">
          <template slot-scope="scope">{{ scope.row.create_time | format_date }}</template>
        </el-table-column>
        <el-table-column prop="username" label="用户名" width="180"></el-table-column>
        <el-table-column prop="role" label="角色">
          <template slot-scope="scope">
            {{ scope.row.role || scope.row.is_admin && '超级管理员' }}
          </template>
        </el-table-column>
        <el-table-column prop="is_active" label="状态">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.is_active"
              :active-value="true"
              :inactive-value="false"
              disabled>
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="service_openid" label="绑定服务号接收通知">
          <template slot-scope="scope">
            <el-button v-if="scope.row.service_openid && scope.row.service_openid.length > 0" :loading="qrLoading" @click="handleUnBindQr(scope.row)" type="danger" plain size="small">解绑</el-button>
            <el-button v-else :loading="qrLoading" @click="handleBindQr" type="success" size="small">绑定</el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button v-if="!scope.row.is_admin" @click="handleEditInfo(scope.row)" type="text" size="small">编辑</el-button>
            <el-button v-permission="['admin']" v-else @click="handleChangeSelfPwd" type="text" size="small">修改登录密码</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 弹窗 -->
    <el-dialog title="员工信息" :visible.sync="dialogFormVisible" width="460px">
      <rs-form :model="form" :errors="formErrors" :rules="rules" ref="form" label-width="120">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="form.username" :disabled="!!form.id"></el-input>
        </el-form-item>
        <el-form-item label="密码" v-if="!!form.id && !form.is_admin" prop="change_password">
          <el-input v-model="form.password" placeholder="留空则不修改"></el-input>
        </el-form-item>
        <el-form-item label="密码" v-else-if="!form.is_admin" prop="password">
          <el-input v-model="form.password"></el-input>
        </el-form-item>
        <el-form-item label="手机" prop="mobile" v-if="!form.is_admin">
          <el-input v-model="form.mobile"></el-input>
        </el-form-item>
        <el-form-item label="角色" prop="role_id" v-if="!form.is_admin">
          <router-link class="color-blue ml-10" to="/user/role">新增角色</router-link>
          <el-select v-model="form.role_id" class="w-100" placeholder="请选择角色">
            <el-option
              v-for="item in roleList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="is_active" v-if="!form.is_admin">
          <div class="w-100">
            <el-switch
              v-model="form.is_active"
              :active-value="true"
              :inactive-value="false">
            </el-switch>
          </div>
        </el-form-item>
      </rs-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit" :loading="dialogSubmitLoading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUser, getUserList, createUser, updateUser } from '@/api/user'
import { getRolesList } from '@/api/role'
import { mapGetters } from 'vuex'
import { bindServiceQr, unBindService } from '@/api/shop.js'

export default {
  data() {
    var checkUsername = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('用户名不能为空'))
      }
      var patternEmail = /^([a-zA-Z]|[0-9])(\w|-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/
      var patternName = /^([A-Za-z])([A-Za-z0-9])+$/
      if (!patternEmail.test(value) && !patternName.test(value)) {
        return callback(new Error('请使用“邮箱”或者“英文+数字“组合的用户名'))
      }
      callback()
    }
    return {
      bodyLoding: false,
      qrLoading: false,
      tableData: [],
      dialogSubmitLoading: false,
      dialogFormVisible: false,
      form: {
        username: null,
        password: null,
        mobile: null,
        role_id: null,
        is_admin: false,
        is_active: false
      },
      roleList: [],
      formErrors: {},
      rules: {
        username: [
          { validator: checkUsername, trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
        ],
        role_id: [
          { required: true, message: '请选择角色', trigger: 'change' },
        ]
      }
    }
  },
  computed: {
    ...mapGetters([
      'username',
      'userInfo',
    ])
  },
  created() {
    this.loadUserList();
  },
  methods: {
    // 记载员工列表
    loadUserList() {
      this.bodyLoding = true
      getUserList().then(res => {
        this.bodyLoding = false
        this.tableData = res.results || []
      })
      getRolesList().then(res => {
        this.roleList = res.results || []
      })
    },
    // 触发编辑
    handleEditInfo(row) {
      getUser(row.id).then(res => {
        this.form = res
      })
      // this.form = row;
      this.dialogFormVisible = true;
      // this.$nextTick(() => {
      //   this.$refs['form'].resetFields();
      // });
    },
    handleChangeSelfPwd() {
      this.$store.commit('CHANGE_PASSWORD', true)
    },
    // 提交数据
    submit(e) {
      e.preventDefault();
      this.$refs['form'].validate((valid) => {
        if (!valid) return false;
        // 发送请求
        this.dialogSubmitLoading = true;
        this.saveData().then(() => {
          this.loadUserList();
          this.dialogFormVisible = false;
          this.dialogSubmitLoading = false;
        }).catch(err => {
          this.formErrors = err.data || {};
          this.dialogSubmitLoading = false;
        })
      });
    },
    saveData() {
      return this.form.id
        ? updateUser(this.form.id, {
          password: this.form.password,
          mobile: this.form.mobile,
          role_id: this.form.role_id,
          is_active: this.form.is_active
        })
        : createUser(this.form)
    },
    // 触发新增
    handleCreate() {
      this.form = {
        username: null,
        password: null,
        mobile: null,
        role_id: null,
        is_admin: false,
        is_active: false
      }
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs['form'].resetFields();
      });
    },
    async handleBindQr() {
      this.qrLoading = true

      try {
        // await unBindService()
        const res = await bindServiceQr()

        this.qrLoading = false
        this.$alert('<img style="width:390px" src="https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=' + res.ticket + '">', '使用微信扫一扫关注绑定服务号', {
          dangerouslyUseHTMLString: true
        });
        this.loadUserList();
      } catch (e) {
        this.$alert(JSON.stringify(e.data), '严重错误', {
          confirmButtonText: '确定',
        });
        this.qrLoading = false
        this.loadUserList();
      }
    },
    async handleUnBindQr(row) {
      await unBindService(row.id)
      this.qrLoading = false
      this.loadUserList();
    }
  }
}
</script>

<style scoped>
</style>
